<template>
    <div class="x-card"
        :class="{ 'x-card--indent': indent }">
        <div class="x-card__title">
            <x-title v-if='title || $slots.title'
                :title="title" :is-child="isChild" :parent-app-name="parentAppName">
                <slot name='title'></slot>
            </x-title>
        </div>
        <div class="x-card__header"
            v-if="$slots.header && $slots.header.length">
            <slot name="header"></slot>
        </div>
        <div class="x-card__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import XTitle from './x-title'

export default {
    name: 'XCard',

    props: {
        title: String,
        indent: {
            type: Boolean,
            default: true
        },
        isChild: {
            Type: Boolean,
            default: false
        },
        parentAppName: String
    },

    components: { XTitle }
}
</script>

<style lang="less">
@import '~common/less/var.less';

.x-card {
    position: relative;
    margin-bottom: 20px;
    background: #ffffff;
    box-shadow: @shadow-page;
    &__title {
        padding: 0 20px;
    }
    &__content {
        position: relative;
        padding: 20px;
    }
    &.x-card--indent {
        .x-card__content {
            > .el-form {
                padding: 0 20px;
            }
        }
    }
}
</style>

